import styled from "styled-components";
import { HeadLine1, HeadLine3, BodyDefault, VerySmall, BodySmall, BodyMedium } from "../../../components/typography/styled";
import { statusColor } from "../../../utils/statusColor";


export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 30px 50px 20px;
  box-sizing: border-box;
  position: relative;
  align-items: flex-start;
  min-width: 0;

  @media screen and (max-width: 900px) {
    padding: 10px 16px 32px;
  }
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  /* margin-top: 20px; */
  margin-bottom: 20px;
  max-width:500px;
  word-break: break-word;
`

export const RowHeader = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  width:100%;
  margin-top:10px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;

    ${TitleBig} {
      max-width: 100%;
      margin-bottom: 0;
    }
  }
`
export const BodyTicket = styled.div`
  display:flex;
  flex-direction:row;
  gap:30px;
  width: 100%;
  margin-top: 10px;
  justify-content:space-between;
  align-items:flex-start;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`

export const TicketOverflow = styled.div`
  display: flex;
  flex-direction:column;
  /* height: 700px; */
  /* padding-right:20px; */
  box-sizing: border-box;
  gap:20px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
`
export const TicketColumn = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  min-width: 0;
  max-width: 100%;
`


export const EnterDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding:20px;
  box-sizing: border-box;
  width: 100%;
  align-items:flex-start;
  background: ${({theme}) => theme.palette[200]};
  border-radius: 8px;
  gap:10px;
  margin-top:20px;
  min-width: 0;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    padding: 14px;
  }
`
